


































import { safeWindow } from 'frontend/utils/window';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Location } from 'vue-router';

@Component
export default class PrivacyBanner extends Vue {
  $refs!: Vue['$refs'] & {
    privacyBanner: HTMLInputElement;
  };
  private showBanner = true;

  private async clickPreferences(location: Location) {
    await this.confirmViewedPrivacyBanner();
    await this.$router.push(location);
  }

  private async dismissBanner() {
    this.showBanner = false;
    this.updateBannerHeight();
    await this.confirmViewedPrivacyBanner();
  }

  private async confirmViewedPrivacyBanner() {
    await this.$store.dispatch('globals/closePrivacyBanner');
  }

  private updateBannerHeight(): void {
    if (!this.$refs.privacyBanner || !this.showBanner) {
      this.$store.commit('globals/setPrivacyBannerHeight', 0);
      return;
    }
    const height = this.$refs.privacyBanner.clientHeight;
    this.$store.commit('globals/setPrivacyBannerHeight', height);
  }

  private mounted(): void {
    this.updateBannerHeight();
    safeWindow()?.addEventListener('resize', this.updateBannerHeight);
  }

  private destroyed(): void {
    safeWindow()?.removeEventListener('resize', this.updateBannerHeight);
  }
}
